import React from "react";

// Barras que se mueven con el volumen real (nivel 0..1).
export default function OndaAudio({ nivel = 0, barras = 9, color = "#C9A84C" }) {
  return (
    <div className="flex items-center gap-1 h-8" data-testid="onda-audio">
      {[...Array(barras)].map((_, i) => {
        const centro = 1 - Math.abs(i - (barras - 1) / 2) / barras;
        const h = 4 + nivel * 26 * (0.5 + centro) * (0.6 + Math.random() * 0.6);
        return <span key={i} className="w-1 rounded-full" style={{ height: `${Math.min(30, h)}px`, background: color, transition: "height 120ms ease" }} />;
      })}
    </div>
  );
}
